import type Page from "./Page";

//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import BaseModel from "./BaseModel";
import PageReferenceTreeviewModel from "../modelTreeViews/PageReferenceTreeviewModel";
ObjectFactory.registerClass("PdfPageReference", (data?: any, parent?: BaseModel) => {
  return new PdfPageReference(data, parent as Page);
});

export default class PdfPageReference extends BaseModel {
  public get className(): string {
    return "PdfPageReference"; // no itx
  }

  /// copy from page !!!!
  scrollLeft: number = 0;
  scrollTop: number = 0;

  ///////////////////////////////////////////////

  referencedPage?: Page;
  pageNumber = 1;

  constructor(data: { pageNumber: number; name: string }, parent: Page) {
    super(data, parent);
    this.referencedPage = parent;
    this.pageNumber = data.pageNumber;
    this.name = data.name;

    this.treeViewModel = new PageReferenceTreeviewModel(this);
  }

  getTag(): string {
    var res = `${this.pageNumber}`;
    if (res.length < 2) {
      res = "0" + res;
    }
    return res;
  }
  setTag(newValue: string) {}

  getName(): string {
    return this._name || "";
  }
  setName(newValue: string) {
    this._name = newValue;
  }

  get usageParentIds(): Array<string> {
    let usage = new Array<string>();
    state.allFloorPags().forEach((page) => {
      if (this.parent?.className == "Page") {
        if (page.pdfPageRefId == this.parent.id && page.parent && page.pageNumber == this.pageNumber) {
          usage.push(page.parent.id);
        }
      } else if (page.pdfPageRefId == this.id && page.parent && page.pageNumber == this.pageNumber) {
        usage.push(page.parent.id);
      }
    });
    return usage;
  }
}
